var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_332_2219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C5.3736 24 0 18.6264 0 12C0 5.3736 5.3736 0 12 0C18.6264 0 24 5.3736 24 12C24 18.6264 18.6264 24 12 24Z",
    fill: "#0078B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.42042 9.29527H7.61002V19.5601H4.42042V9.29527ZM6.01642 4.19287C7.03642 4.19287 7.86442 5.02087 7.86442 6.04327C7.86442 7.06567 7.03642 7.89367 6.01642 7.89367C4.99402 7.89367 4.16602 7.06567 4.16602 6.04327C4.16362 5.02327 4.99162 4.19287 6.01642 4.19287Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.61133 9.29537H12.6713V10.697H12.7145C13.1393 9.89057 14.1785 9.03857 15.7337 9.03857C18.9641 9.03857 19.5617 11.165 19.5617 13.9274V19.5602H16.3721V14.5706C16.3721 13.3778 16.3505 11.849 14.7137 11.849C13.0529 11.849 12.7985 13.145 12.7985 14.4842V19.5626H9.61133V9.29537Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_332_2219"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin_icon.1ebe385f63b1bbe59c97cac4b5c8059c.svg";
export { ForwardRef as ReactComponent };